import {publicApi, token} from "./apiConfiguration";

export default class AuthService {

    static async login() {
        await publicApi.post("/user-service/login/mobile", token).then(response => {
            localStorage.setItem('authToken', response.headers.authorization)
        })
    }

}
